import type { ReactNode } from "react";

import { avatarPlateStyle } from "../profile/avatarPlateStyle";
import { initialsFromTitle } from "./chatDisplay";

export type typeMentionMember = { userId: string; displayName: string };

export type typeMentionSuggestionListProps = {
  /** Already filtered by the caller (the composer), case-insensitive
   * `startsWith` against the substring typed after `@`. This component only
   * renders whatever list it is given. */
  members: typeMentionMember[];
  query: string;
  onSelect: (member: typeMentionMember) => void;
};

export const MentionSuggestionList = (
  props: typeMentionSuggestionListProps,
): ReactNode => {
  if (props.members.length === 0) return null;

  return (
    <ul className="max-h-48 overflow-y-auto rounded-md border border-hairline bg-surface">
      {props.members.map((member) => (
        <li key={member.userId}>
          <button
            type="button"
            onClick={() => {
              props.onSelect(member);
            }}
            className="flex min-h-touch-target w-full items-center gap-2 px-3"
          >
            <span
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-caption"
              style={avatarPlateStyle(member.displayName)}
            >
              {initialsFromTitle(member.displayName)}
            </span>
            <span className="text-body text-ink">{member.displayName}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};
